/* AUTAVEX — екошкіра: кольори вишивки */
window.AV_EK_THR=[
 ['\u0427\u043e\u0440\u043d\u0430','#1F2123'],
 ['\u0422\u0435\u043c\u043d\u043e-\u0441\u0456\u0440\u0430','#4C5053'],
 ['\u0421\u0456\u0440\u0430','#7E8388'],
 ['\u0421\u0432\u0456\u0442\u043b\u043e-\u0441\u0456\u0440\u0430','#B4B9BC'],
 ['\u0411\u0456\u043b\u0430','#F2F0EA'],
 ['\u0421\u0432\u0456\u0442\u043b\u0438\u0439 \u0431\u0435\u0436','#E6DFCB'],
 ['\u0411\u0435\u0436\u0435\u0432\u0430','#C9B18B'],
 ['\u041c\u043e\u043a\u043a\u043e','#8A6A55'],
 ['\u041a\u043e\u0440\u0438\u0447\u043d\u0435\u0432\u0430','#6B4A33'],
 ['\u0428\u043e\u043a\u043e\u043b\u0430\u0434\u043d\u0430','#4A3327'],
 ['\u0427\u0435\u0440\u0432\u043e\u043d\u0430','#A8232B'],
 ['\u0411\u043e\u0440\u0434\u043e\u0432\u0430','#6E2733'],
 ['\u0420\u043e\u0436\u0435\u0432\u0430','#C4788F'],
 ['\u0424\u0443\u043a\u0441\u0456\u044f','#B33C86'],
 ['\u0424\u0456\u043e\u043b\u0435\u0442\u043e\u0432\u0430','#6B4A8C'],
 ['\u041b\u0430\u0432\u0430\u043d\u0434\u043e\u0432\u0430','#8E86B8'],
 ['\u041e\u0440\u0430\u043d\u0436\u0435\u0432\u0430','#D2691B'],
 ['\u0416\u043e\u0432\u0442\u0430','#D2A916'],
 ['\u0425\u0430\u043a\u0456','#6E6B47'],
 ['\u0417\u0435\u043b\u0435\u043d\u0430','#33613D'],
 ['\u0411\u0456\u0440\u044e\u0437\u043e\u0432\u0430','#2E8B84'],
 ['\u0413\u043e\u043b\u0443\u0431\u0430','#7FA6C4'],
 ['\u0421\u0438\u043d\u044f','#2E5A8C'],
 ['\u0422\u0435\u043c\u043d\u043e-\u0441\u0438\u043d\u044f','#1E2C48'],
 ['\u0417\u043e\u043b\u043e\u0442\u043e','#C9A227',1],
 ['\u0421\u0440\u0456\u0431\u043b\u043e','#B9BDC2',1]
];
